<template>
    <div class="exchange">
        <div class="placeholder"></div>
        <div class="exchange-bg"></div>
        <div class="exchange-popover">
            <div class="exchange-popover-title">
                YUX/USDT
                <img src="../../assets/img/exchange/icon1.png" alt="">
            </div>
        </div>
        <Tabs v-model="active" @click="handleTab" :border="true" type="line">
            <Tab name="m1">
                <template #title>
                    <div class="tabs-title">
                        M1
                    </div>
                </template>


            </Tab>
            <Tab name="m5">
                <template #title>
                    <div class="tabs-title">
                        M5
                    </div>
                </template>

            </Tab>
            <Tab name="m15">
                <template #title>
                    <div class="tabs-title">
                        M15
                    </div>
                </template>


            </Tab>
            <Tab name="m30">
                <template #title>
                    <div class="tabs-title">
                        M30
                    </div>
                </template>
            </Tab>
            <Tab name="h1">
                <template #title>
                    <div class="tabs-title">
                        H1
                    </div>
                </template>

            </Tab>
        </Tabs>
        <div ref="main" style="height: 300px;"></div>

        <div class="exchange-content">

            <div class="title">
                {{ $t('exchange.market') }}
            </div>

            <div class="market">
                <div>
                    <div class="market-t">
                        {{ $t('exchange.payment') }}
                        <div>
                            <img src="../../assets/img/exchange/icon8.png" alt="">
                            {{auxBalance}}
                            <span @click="all()">{{ $t('exchange.all') }}</span>
                        </div>
                    </div>

                    <div class="market-c">
                        <div class="market-card">
                            <div class="market-card-l">
                                <img src="../../assets/img/exchange/icon4.png" alt="">
                                <img class="icon-fixed" src="../../assets/img/exchange/icon5.png" alt="">
                            </div>
                            <div class="market-card-r">
                                <div class="market-card-r-title">
                                    YUX
                                    <img src="../../assets/img/exchange/icon6.png" alt="">
                                </div>
                                <div class="market-card-r-desc">NEX Chain</div>
                            </div>
                        </div>
                        <div class="market-c-r">
                            <div class="ipt">
                                <Field v-model="value1" placeholder="请输入兑换数量" @input="onInput"  @blur="fonblur()"  ></Field>
                            </div>
                        </div>
                    </div>

                    <div class="market-arrow">
                        <span>{{ $t('exchange.received') }}</span>
                        <img src="../../assets/img/exchange/icon9.png" alt="">
                        <span></span>
                    </div>

                    <div class="market-c">
                        <div class="market-card">
                            <div class="market-card-l">
                                <img src="../../assets/img/exchange/icon7.png" alt="">
                                <img class="icon-fixed" src="../../assets/img/exchange/icon5.png" alt="">
                            </div>
                            <div class="market-card-r">
                                <div class="market-card-r-title">
                                    USDT
                                    <img src="../../assets/img/exchange/icon6.png" alt="">
                                </div>
                                <div class="market-card-r-desc">NEX Chain</div>
                            </div>
                        </div>
                        <div class="market-c-r">
                            <div class="ipt">
                                <Field v-model="value2"   @blur="fonblur()"  ></Field>
                            </div>
                        </div>

                    </div>


                    <div class="market-rate">
                        1 YUX ≈ {{auxPrice}} USDT
                    </div>
                    <div class="market-desc">
                        <div>
                            <span class="label">{{ $t('exchange.slippage') }}</span>
                            <span class="value">{{exchangefee}}%</span>
                        </div>

                        <div>
                            <span class="label">{{ $t('exchange.minimum') }}</span>
                            <span class="value">{{smallu}} USDT</span>
                        </div>
                    </div>

                    <div class="market-btn" @click="doExchange()">
                        {{ $t('exchange.confirmExchange') }}
                    </div>
                </div>
            </div>

            <div class="title">
                {{ $t('exchange.record') }}
            </div>

            <div class="card" v-for="(item,i) in listorder" :key="i">
                <div>
                    <div class="card-title">
                        <span>{{item.AddTime}}</span>
                        <div>
                            <div class="btn">
                                {{ $t('exchange.completed') }}
                            </div>
                            <img src="../../assets/img/exchange/icon3.png" alt="">
                        </div>
                    </div>

                    <div class="card-content">
                        <div class="card-content-l">
                            <div class="card-content-l-l">
                                <img src="../../assets/img/exchange/icon4.png" alt="">
                                <img class="icon-fixed" src="../../assets/img/exchange/icon5.png" alt="">
                            </div>
                            <div class="card-content-l-r">
                                <div class="card-content-l-r-title">
                                    YUX
                                    <img src="../../assets/img/exchange/icon11.png" alt="">
                                </div>
                                <div class="card-content-l-r-desc">NEX Chain</div>
                            </div>
                        </div>
                        <div class="line">
                            <Icon class="icon" name="play" />
                        </div>
                        <div class="card-content-l">
                            <div class="card-content-l-l">
                                <img src="../../assets/img/exchange/icon7.png" alt="">
                                <img class="icon-fixed" src="../../assets/img/exchange/icon5.png" alt="">
                            </div>
                            <div class="card-content-l-r">
                                <div class="card-content-l-r-title">
                                    USDT
                                    <img src="../../assets/img/exchange/icon11.png" alt="">
                                </div>
                                <div class="card-content-l-r-desc">NEX Chain</div>
                            </div>
                        </div>
                    </div>

                    <div class="card-footer">
                        {{item.Amount}} YUX = {{item.Quantity}} USDT
                    </div>
                </div>
            </div>


            <!-- <div class="more">
                {{ $t('exchange.downMore') }}
            </div> -->
        </div>

        <Popup v-model="show" position="bottom" round get-container="#app" @closed="onClose">
            <div v-if="!loading && !claimOk" class="exchange-popup">
                <div class="title">
                    {{ $t('exchange.confirmExchange') }}
                    <img src="../../assets/img/node/icon7.png" @click="show = false" alt="">
                </div>
                <div class="ipt">
                    <Field v-model="value" placeholder="" input-align="right">
                        <template #label>
                            <div class="label">
                                <div class="exchange-icon">
                                    <img src="../../assets/img/exchange/icon7.png" alt="">
                                    <img class="icon-fixed" src="../../assets/img/exchange/icon5.png" alt="">
                                </div>
                                <span>YUX</span>
                            </div>
                        </template>
                    </Field>
                </div>
                <div class="exchange-popup-icon">
                    <img src="../../assets/img/exchange/icon10.png" alt="">

                </div>

                <div class="ipt">
                    <Field v-model="value" placeholder="" input-align="right">
                        <template #label>
                            <div class="label">
                                <div class="exchange-icon">
                                    <img src="../../assets/img/exchange/icon7.png" alt="">
                                    <img class="icon-fixed" src="../../assets/img/exchange/icon5.png" alt="">
                                </div>
                                <span>YUX</span>
                            </div>
                        </template>
                    </Field>
                </div>


                <div class="desc">
                    <div>
                        <div>
                            <div class="label">{{ $t('exchange.price') }}</div>
                            <div class="value">1 YUX≈ 2.34 USDT</div>
                        </div>

                        <div>
                            <div class="label">{{ $t('exchange.slippage') }}</div>
                            <div class="value">Auto 0.5%</div>
                        </div>

                        <div>
                            <div class="label">{{ $t('exchange.minimum') }}</div>
                            <div class="value">0.23536 USDT</div>
                        </div>

                        <div>
                            <div class="label">{{ $t('exchange.cost') }}</div>
                            <div class="value">0.00032 YUX</div>
                        </div>
                    </div>
                </div>
                <div class="btn" @click="handleClaim">
                    {{ $t('exchange.confirmExchange') }}
                </div>
            </div>
            <div class="revenue-loading" v-if="loading">
                <div class="title">
                    {{ $t('exchange.progress') }}
                    <img src="../../assets/img/node/icon7.png" @click="show = false" alt="">
                </div>
                <div class="loading">
                    <div class="loader-inner ball-spin-fade-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <div class="desc"> {{ $t('exchange.progress') }}</div>
            </div>
            <div class="revenue-claim" v-if="claimOk && !loading">
                <div class="title">
                    {{ $t('exchange.executionSuccessful') }}
                    <img src="../../assets/img/node/icon7.png" @click="show = false" alt="">
                </div>
                <div class="claim-ok">
                    <img src="../../assets/img/node/claim.png" alt="">
                    <div class="title">
                        {{ $t('exchange.executionSuccessful') }}
                    </div>
                    <div class="desc">
                        <span>{{ $t('exchange.at') }}Nexus Chain {{ $t('exchange.view') }}:0xe7d92</span>
                        <img src="../../assets/img/node/icon8.png" alt="">
                    </div>
                </div>

            </div>
        </Popup>



        <Popup v-model="nodeShow" position="bottom" round get-container="#app" @closed="onClose">
            <div v-if="!loading && !claimOk" class="exchange-popup node-popup">
                <div class="title">
                    {{ $t('exchange.nodeSubscription') }}
                    <img src="../../assets/img/node/icon7.png" @click="nodeShow = false" alt="">
                </div>

                <div class="desc">
                    <div>
                        <div>
                            <div class="label"> {{ $t('exchange.wallet') }}</div>
                            <div class="value">0x2415a...c6aaec61bf4d</div>
                        </div>

                        <div>
                            <div class="label"> {{ $t('exchange.cost') }}</div>
                            <div class="value">0.00032 BNB</div>
                        </div>

                        <div>
                            <div class="label"> {{ $t('exchange.nonce') }}</div>
                            <div class="value">7</div>
                        </div>
                    </div>
                </div>
                <div class=" node-popup-btn">
                    <div class="nook" @click="nodeShow = false">
                        <div>
                            {{ $t('exchange.refuse') }}
                        </div>
                    </div>
                    <div class="ok" @click="handleClaim"> {{ $t('exchange.confirm') }}</div>
                </div>
            </div>
            <div class="revenue-loading" v-if="loading">
                <div class="title">
                    {{ $t('exchange.progress') }}
                    <img src="../../assets/img/node/icon7.png" @click="nodeShow = false" alt="">
                </div>
                <div class="loading">
                    <div class="loader-inner ball-spin-fade-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <div class="desc"> {{ $t('exchange.progress') }}</div>
            </div>
            <div class="revenue-claim" v-if="claimOk && !loading">
                <div class="title">
                    {{ $t('exchange.executionSuccessful') }}
                    <img src="../../assets/img/node/icon7.png" @click="nodeShow = false" alt="">
                </div>
                <div class="claim-ok">
                    <img src="../../assets/img/node/claim.png" alt="">
                    <div class="title">
                        {{ $t('exchange.executionSuccessful') }}
                    </div>
                    <div class="desc">
                        <span>{{ $t('exchange.at') }}Nexus Chain {{ $t('exchange.view') }}:0xe7d92</span>
                        <img src="../../assets/img/node/icon8.png" alt="">
                    </div>
                </div>

            </div>
        </Popup>
    </div>
</template>

<script>
import {
    Field,
    Swipe,
    SwipeItem,
    Circle,
    Tab,
    Tabs,
    Popup,
    Progress,
    Button,
    Popover,
    Icon
} from "vant";
import NumberScroll from "@/components/NumberScroll.vue";
import SplitText from "@/components/SplitText/SplitText.vue";
import ShinyText from "@/components/ShinyText/ShinyText.vue";
import AnimatedContent from "@/components/AnimatedContent/AnimatedContent.vue";
import FadeContent from "@/components/FadeContent/FadeContent.vue";
import * as echarts from 'echarts';
import { data as rawData } from './data'
import { aggregateToKLine, calculateMA, formatChartData, PERIOD_CONFIG } from "./echarts"
// console.log(rawData)

import axios from 'axios'
import Web3 from 'web3'
import contractaa from '../contract/index.js'
let web3
web3 = new Web3(window.ethereum)

export default {
    name: "exchange",
    components: {
        Popover,
        SplitText,
        Icon,
        ShinyText,
        AnimatedContent,
        FadeContent,
        Field,
        Swipe,
        SwipeItem,
        Tab,
        VanCircle: Circle,
        Tabs,
        Popup,
        Progress,
        Button,
        NumberScroll,
    },
    data() {
        return {
            value: "0.023436",
            active: '1',
            showPopover: false,
            show: false,
            nodeShow: false,
            claimOk: false,
            loading: false,
            activePeriod: 'm1', // 默认激活1分钟周期
            allPeriodData: {}, // 存储所有周期的聚合数据和格式化数据
            periodList: Object.values(PERIOD_CONFIG), // 周期列表
            value1:'',
            value2:'0',
            auxBalance:0,
            auxPrice:0,
            exchangefee:0,
            smallu:0,
            listorder:[]
        };
    },
    computed: {
        // 当前激活周期的配置
        currentConfig() {
            return PERIOD_CONFIG[this.activePeriod];
        },
        currentData() {
            return this.allPeriodData[this.activePeriod];
        }
    },
    mounted() {

        setTimeout(() => {
            this.getInfo()
            this.initAllPeriodData()
        }, 200)
    },
    methods: {
        handleTab(name) {
            this.activePeriod = name;
            this.initAllPeriodData()
        },
        onInput(val) {
            // 只允许数字和小数点
            val = val.replace(/[^\d.]/g, '')

            // 只保留第一个小数点
            const firstDot = val.indexOf('.')
            if (firstDot !== -1) {
                const before = val.slice(0, firstDot + 1)
                const after = val.slice(firstDot + 1).replace(/\./g, '')
                val = before + after
            }

            this.value1 = val
            return val
        },
        handleClaim() {
            this.loading = true;
            setTimeout(() => {
                this.claimOk = true;
                this.loading = false;

            }, 2000)
        },
        all(){
            this.value1 = this.auxBalance
            let _fee = this.exchangefee
            let _exchangeAux =Number(this.value1)*(1-Number(_fee)/100);
            let _usdt =   Number(_exchangeAux)*Number(this.auxPrice)
            this.value2 = _usdt
            this.smallu = _usdt
        },
        fonblur(){
            let _fee = this.exchangefee
            let _exchangeAux =Number(this.value1)*(1-Number(_fee)/100);
            let _usdt =   Number(_exchangeAux)*Number(this.auxPrice)
            this.value2 = _usdt
            this.smallu = _usdt
        },
        onClose() {
            this.loading = false;
            this.claimOk = false;
            this.show = false;
            this.nodeShow = false
        },
        async getInfo(){
            let that = this;
            let address = this.$store.state.globalAddress;

            console.log(address);

            
            let ExchangeContract = new web3.eth.Contract(contractaa.abiExchange,contractaa.exchangeToken);
            let AuxContract = new web3.eth.Contract(contractaa.abiUsdt,contractaa.yuxToken);
            
            await AuxContract.methods.balanceOf(address).call({from:address}).then(function(result){
                that.auxBalance = web3.utils.fromWei(result,'ether')
            })
            await ExchangeContract.methods.price().call({from:address}).then(function(result){
                that.auxPrice = web3.utils.fromWei(result,'ether')
            })
            await ExchangeContract.methods.exchangeAFee().call({from:address}).then(function(result){
                that.exchangefee = Number(result)/10
            })
            axios.get(contractaa.APIURL+'?cmd=getorder&addr='+ address).then(function (response) {
                if (response.status === 200) {
                       that.listorder = response.data.Data;
                    }
                })

        },
        async doExchange(){

            let that = this;
            let address = this.$store.state.globalAddress;
            var AuxContract = new web3.eth.Contract(contractaa.abiUsdt,contractaa.yuxToken);
            var ExchangeContract = new web3.eth.Contract(contractaa.abiExchange,contractaa.exchangeToken);

            let _amount = that.value1
           
            let maxmunber = '115792089237316195423570985008687907853269984665640564039457584007913129639935';
            that.$store.commit('handleShow', true)
            AuxContract.methods.allowance(address,contractaa.exchangeToken).call({from:address}).then(function(result){
                //获取 result 授权数量
                let dd = web3.utils.fromWei(result,'ether')
                console.log('授权数量'+dd);
                if(dd >= _amount){
                    ExchangeContract.methods.ExchangeAtoUSDT(web3.utils.toWei(_amount,'ether')).send({from:address}).then(receipt => {
                        //监听后续的交易情况
                        if (receipt.status == "1") {
                            axios.get(contractaa.APIURL+'?cmd=addexchange&tx='+receipt.transactionHash).then(function (response) {
                            if (response.status === 200) {
                                    console.log("axios:"+response.data.Message)
                                }
                            })
                            //that.$toast.success(that.$t('node.success'));
                            that.$store.commit('handleLoading', false)
                            that.getInfo();

                        } else {
                            that.$toast.fail(that.$t('node.error'));
                        }          
                    });
                }else{
                    AuxContract.methods.approve(contractaa.exchangeToken,maxmunber).send({from:address}).then(receipt => {
                        //监听后续的交易情况
                        if (receipt.status == "1") {
                            ExchangeContract.methods.ExchangeAtoUSDT(web3.utils.toWei(_amount,'ether')).send({from:address}).then(receipt => {
                                    //监听后续的交易情况
                                    if (receipt.status == "1") {
                                        axios.get(contractaa.APIURL+'?cmd=addexchange&tx='+receipt.transactionHash).then(function (response) {
                                        if (response.status === 200) {
                                                console.log("axios:"+response.data.Message)
                                            }
                                        })
                                        //that.$toast.success(that.$t('node.success'));
                                        that.$store.commit('handleLoading', false)
                                        that.getInfo();
                                       
                                    } else {
                                        that.$toast.fail(that.$t('node.error'));
                                    }          
                                });

                        } else {
                           that.$toast.fail(that.$t('node.error'));
                        }          
                    });
                }
            })  
        },
        async initAllPeriodData() {
            try {
                if (!rawData || rawData.length === 0) {
                    throw new Error('原始秒级数据不能为空');
                }

                for (const config of this.periodList) {
                    const kLineData = aggregateToKLine(rawData, config.aggregateMin);
                    const maDataList = config.maPeriods.map(period =>
                        calculateMA(kLineData, period)
                    );
                    const formattedData = formatChartData(kLineData);
                    this.allPeriodData[config.code] = {
                        kLineData,
                        maDataList,
                        formattedData
                    };
                }

                this.initChart();
            } catch (error) {
                console.error('数据处理失败：', error);
            }
        },

        initChart() {
            if (!this.currentData) return;
            this.renderChart(
                this.currentData.formattedData,
                this.currentData.maDataList,
                this.currentConfig
            );
        },

        changePeriod(periodCode) {
            if (this.activePeriod === periodCode) return;
            this.activePeriod = periodCode;
            this.renderChart(
                this.currentData.formattedData,
                this.currentData.maDataList,
                this.currentConfig
            );
        },

        // 渲染图表（修复K线格式，优化样式）
        renderChart(formattedData, maDataList, config) {
            const { dates, candlestickData, volumeData, rawMap } = formattedData;
            const chartDom = this.$refs.main;

            if (!chartDom) {
                console.error('未找到图表容器');
                return;
            }

            const myChart = echarts.init(chartDom);

            const getLatestMA = (maData) => {
                for (let i = maData.length - 1; i >= 0; i--) {
                    if (maData[i] !== '-') return maData[i];
                }
                return '0.00';
            };

            const legendData = config.maPeriods.map((period, index) => {
                const maName = `MA${period}`;
                return {
                    name: `${maName}: ${getLatestMA(maDataList[index])}`,
                    textStyle: { color: config.lineColors[index] }
                };
            });

            const series = [
                {
                    name: 'K线',
                    type: 'candlestick',
                    data: candlestickData,
                    itemStyle: {
                        color: config.upColor, // 阳线（收盘>=开盘）填充色
                        color0: config.downColor, // 阴线（收盘<开盘）填充色
                        borderColor: config.upColor, // 阳线边框色
                        borderColor0: config.downColor, // 阴线边框色
                        borderWidth: 1.5, // 边框宽度
                        shadowBlur: 2, // 阴影模糊度
                        shadowColor: 'rgba(0,0,0,0.1)' // 阴影颜色
                    },
                    barSize: '30%', // K线宽度（适配数据密度）
                    barSizeMin: 2, // 最小宽度（避免数据过少时K线过细）
                    z: 5 // 层级（确保K线在最上层）
                },
                // MA线系列
                ...config.maPeriods.map((period, index) => ({
                    name: `MA${period}: ${getLatestMA(maDataList[index])}`,
                    type: 'line',
                    data: maDataList[index],
                    smooth: true,
                    lineStyle: {
                        color: config.lineColors[index],
                        width: 1.2
                    },
                    symbol: 'none',
                    z: 4
                })),

            ];

            const option = {
                animation: true,
                animationDuration: 500,
                legend: {
                    top: 10,
                    left: 'left',
                    itemWidth: 0,
                    itemHeight: 0,
                    itemGap: 15,
                    data: legendData,
                    textStyle: { fontSize: 11, color: '#666' }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'cross',


            crossStyle: {
                color: '#EAC477', // 十字交叉线颜色
                width: 1
            },

                     },
                    borderWidth: 1,
                    borderColor: '#ccc',
                    padding: 12,
                    textStyle: { color: '#000', fontSize: 11 },
                    backgroundColor: 'rgba(255,255,255,0.95)',
                    position: (pos, params, el, elRect, size) => {
                        const obj = { top: 20 };
                        obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
                        return obj;
                    },
                    formatter: (params) => {
                        const kLineParam = params.find(p => p.seriesType === 'candlestick');
                        if (!kLineParam) return '';

                        const time = kLineParam.axisValue;
                        const info = rawMap.get(time) || {};
                        const [index,open, high, low, close] = kLineParam.data;

                        // 涨跌状态（红色=涨，绿色=跌）
                        const changeColor = close >= open ? '#ec0000' : '#00da3c';

                        return `
                            <div style="font-weight: bold; margin-bottom: 4px;">${time}（${config.name}）</div>
                            <div>开盘：<span style="color: ${changeColor}">${open.toFixed(2)}</span></div>
                            <div>收盘：<span style="color: ${changeColor}">${close.toFixed(2)}</span></div>
                            <div>最高：<span style="color: #ec0000">${high.toFixed(2)}</span></div>
                            <div>最低：<span style="color: #00da3c">${low.toFixed(2)}</span></div>
                            <div>涨跌额：<span style="color: ${changeColor}">${info.change || '0.00'}</span></div>
                            <div>涨跌幅：<span style="color: ${changeColor}">${info.changeRate || '0.00%'}</span></div>
                            <div>成交量：${info.volume ? (info.volume >= 10000 ? (info.volume / 10000).toFixed(2) + '万' : info.volume) : '0'}</div>
                        `;
                    }
                },
                grid: {
                    top: '15%',
                    bottom: '30',
                    left: '8%',
                    right: '15%'
                },
                xAxis: {
                    type: 'category',
                    data: dates,
                    boundaryGap: false,
                    splitArea: { show: false },
                    splitLine: { show: false },
                    axisLine: { show: false },
                    axisTick: { show: false },
                    axisLabel: {
                        color: '#969696',
                        
                    },
                },
                yAxis: [
                    // 价格轴（右侧）
                    {
                        type: 'value',
                        scale: true,
                        position: 'right',
                        splitArea: { show: false },
                        splitLine: {
                            show: true,
                            lineStyle: { color: '#242424', width: 1 }
                        },
                        axisLine: { show: false },
                        axisTick: { show: false, },
                        axisLabel: {
                            color: '#969696',
                            fontSize: 10,
                            formatter: (val) => val.toFixed(2),
                            
                        },
                        max: (value) => value.max * 1.05,
                        min: (value) => value.min * 0.95
                    },
                    {
                        type: 'value',
                        scale: true,
                        position: 'left',
                        splitArea: { show: false },
                        splitLine: { show: false },
                        axisLine: { show: false },
                        axisTick: { show: false },
                        axisLabel: {
                            color: '#666',
                            fontSize: 9,
                            formatter: (val) => val >= 10000 ? (val / 10000).toFixed(1) + '万' : val
                        },
                        max: (value) => value.max * 1.1,
                        min: 0
                    }
                ],
                dataZoom: [
                    {
                        show: false,
                        type: 'slider',
                    },
                    { show: false, type: 'inside' }
                ],
                series: series
            };

            myChart.setOption(option, true);

            const resizeHandler = () => myChart.resize();
            window.removeEventListener('resize', resizeHandler);
            window.addEventListener('resize', resizeHandler);
            this.$once('hook:beforeDestroy', () => {
                window.removeEventListener('resize', resizeHandler);
                myChart.dispose();
            });
        }
    },
};
</script>

<style lang="less" scoped>
.exchange {
    position: relative;
    //overflow-x: hidden;
    //height: 100%;
    //min-height: 100%;
    background-size: 100% 800px;
    padding: 0 0 42px;
    background: url("../../assets/img/home/header-bg.png") no-repeat;
    background-size: 471.9px 240.62px;
    background-position: -60px -97px;

    &-bg {
        width: 375px;
        position: absolute;
        height: 178px;
        top: -44px;
        background: url('../../assets/img/layout/bg.png') no-repeat center;
        background-size: 100% 100%;
    }

    .placeholder {
        height: 34px;
    }

    .px15 {
        padding: 0 15px;
    }

    .exchange-popover {
        padding: 0 20px;
        margin-top: 24px;
        position: relative;
        z-index: 2;

        &-title {
            display: flex;
            font-weight: bold;
            font-size: 16px;
            align-items: center;

            img {
                width: 16px;
                height: 16px;
                margin-left: 4px;
            }
        }
    }

    .tabs-title {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #969696;

        >img {
            width: 12px;
            height: 12px;
        }
    }

    .exchange-content {
        padding: 0 20px;
        margin-top: 30px;

        >.title {
            font-size: 16px;
            font-weight: bold;
        }

        .market {
            margin-top: 16px;
            border-radius: 16px;
            box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);
            background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 36px;

            >div {
                height: 443px;
                padding: 15px 16px 20px;
                background: linear-gradient(241deg, #1E1D24 9%, #13121B 78%);
                backdrop-filter: blur(30px);
                border-radius: 16px;
                width: calc(100% - 2px);
                height: calc(100% - 2px);

                .market-t {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 14px;
                    line-height: 20px;

                    >div {
                        display: flex;
                        align-items: center;

                        >img {
                            margin-right: 9px;
                            width: 16px;
                            height: 16px;
                        }

                        >span {
                            color: linear-gradient(133deg, #0DF1D5 2%, #0190D1 98%);
                            margin-left: 16px;
                        }
                    }
                }

                .market-c {
                    margin-top: 14px;
                    height: 63px;
                    padding: 14px 16px;
                    background: url('../../assets/img/exchange/bg.png') no-repeat;
                    background-size: 100% 100%;

                    border-radius: 16px;
                    backdrop-filter: blur(46px);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    &-r {
                        text-align: right;

                        .label {
                            line-height: 16px;
                            font-size: 15px;
                            font-weight: 500;
                        }

                        .value {
                            font-size: 12px;
                            opacity: 0.6;
                        }
                    }
                }

                .market-card {
                    display: flex;
                    align-items: center;

                    &-l {
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 32px;
                        height: 32px;

                        >img {
                            width: 32px;
                            height: 32px;
                        }

                        .icon-fixed {
                            width: 12px !important;
                            height: 12px !important;
                            position: absolute;
                            right: 0;
                            bottom: 0;
                        }
                    }

                    &-r {
                        margin-left: 12px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;

                        &-title {
                            font-size: 15px;
                            font-weight: 500;
                            line-height: 16px;
                            display: flex;
                            align-items: center;

                            >img {
                                margin-left: 4px;
                                width: 12px;
                                height: 12px;
                            }
                        }

                        &-desc {
                            opacity: 0.6;
                            margin-top: 4px;
                            font-size: 12px;
                            line-height: 15px;
                        }
                    }
                }

                .market-arrow {
                    margin-top: 16px;
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                    font-size: 14px;

                    >img {
                        width: 32px;
                        height: 32px;
                    }

                    span {
                        display: block;
                        width: 50px;
                    }
                }

                .market-rate {
                    margin-top: 16px;
                    font-size: 12px;
                    opacity: 0.6;
                    line-height: 15px;
                }

                .market-desc {
                    margin-top: 12px;

                    >div {
                        display: flex;
                        justify-content: space-between;
                        font-size: 12px;
                        margin-top: 12px;
                        line-height: 15px;

                        .label {
                            opacity: 0.6;
                        }
                    }
                }

                .market-btn {
                    margin-top: 24px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #000000;
                    height: 48px;
                    font-size: 16px;
                    background: url('../../assets/img/exchange/btn1.png') no-repeat;
                    background-size: 100% 100%;
                    border-radius: 16px;


                }
            }
        }

        .card {
            height: 136px;
            border-radius: 16px;
            margin-top: 16px;


            box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);
            background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;

            >div {
                background: linear-gradient(241deg, #1E1D24 9%, #13121B 78%);
                padding: 12px 16px 0;
                backdrop-filter: blur(30px);
                border-radius: 16px;
                width: calc(100% - 2px);
                height: calc(100% - 2px);

                .card-title {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 16px;
                    align-items: center;

                    >span {
                        font-size: 12px;
                        opacity: 0.6;
                        letter-spacing: -0.25px;
                    }

                    >div {
                        display: flex;
                        align-items: center;
                    }

                    .btn {
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 12px;
                        min-width: 56px;
                        padding: 0 8px;
                        height: 24px;
                        font-weight: 500;
                        background: url('../../assets/img/exchange/bg1.png') no-repeat;
                        background-size: 100% 100%;
                        border-radius: 8px;

                        &.error {
                            background: #FFCBC3;
                            color: #FC4C34;
                        }
                    }

                    img {
                        width: 16px;
                        height: 16px;
                        margin-left: 12px;
                    }
                }

                .card-content {
                    display: flex;
                    align-items: center;

                    .line {
                        position: relative;
                        flex: 1;
                        height: 1px;
                        border-bottom: 1px dashed #fff;
                        margin: 0 12px;

                        .icon {
                            position: absolute;
                            right: -6px;
                            top: 50%;
                            transform: translateY(-50%);

                        }

                    }



                    &-l {
                        display: flex;
                        align-items: center;

                        &-l {
                            position: relative;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 32px;
                            height: 32px;

                            >img {
                                width: 32px;
                                height: 32px;
                            }

                            .icon-fixed {
                                width: 12px !important;
                                height: 12px !important;
                                position: absolute;
                                right: 0;
                                bottom: 0;
                            }
                        }

                        &-r {
                            margin-left: 12px;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;

                            &-title {
                                font-size: 15px;
                                font-weight: 500;
                                line-height: 16px;
                                display: flex;
                                align-items: center;

                                >img {
                                    margin-left: 4px;
                                    width: 12px;
                                    height: 12px;
                                }
                            }

                            &-desc {
                                margin-top: 4px;
                                font-size: 12px;
                                line-height: 15px;
                                opacity: 0.6;
                            }
                        }
                    }
                }

                .card-footer {
                    font-size: 14px;
                    letter-spacing: -0.25px;
                    margin-top: 16px;
                }
            }
        }
    }

    .more {
        font-size: 12px;
        opacity: 0.6;
        line-height: 14px;
        text-align: center;
        margin-top: 12px;
    }


}
</style>
<style lang="less">
.exchange {
    .van-tabs__nav {
        background: #020307;
    }

    .van-tab--active {
        .tabs-title {
            color: #EAC477;

        }
    }

    .van-tabs--line .van-tabs__wrap {
        height: 44px;
    }

    .van-tabs__line {
        border-radius: 0;
        height: 3px;
        background: linear-gradient(180deg, #F8DB8B 0%, #D5A857 100%);
    }

    .van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
        border-top: none;
        border-color: #d9d9d9;
    }
}

.exchange-icon {
    margin-right: 12px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    flex: 1;

    >img {
        width: 32px;
        height: 32px;
    }

    .icon-fixed {
        width: 12px !important;
        height: 12px !important;
        position: absolute;
        right: 0;
        bottom: 0;
    }
}

.van-popup{
  background: #000000;
}
.exchange-popup {
    padding: 32px 20px 40px;
    backdrop-filter: blur(46px);
    background-blend-mode: darken;
    background: #000000;
    border-radius: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.5);

    >.title {
        display: flex;
        justify-content: space-between;
        line-height: 16px;
        font-size: 16px;
        margin-bottom: 24px;

        >img {
            width: 20px;
            height: 20px;
        }
    }

    >.label {
        margin-top: 20px;
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 16px;

    }

    >.ipt {
        height: 54px;
        border-radius: 16px;
        display: flex;
        align-items: center;
        box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);
        background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
        border-radius: 16px;

        >div {
            background: linear-gradient(241deg, #1E1D24 9%, #13121B 78%) !important;
            backdrop-filter: blur(30px);
            border-radius: 16px;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
        }

        .van-field__control {
            color: #fff;
            font-weight: 500;
            font-size: 16px;
            font-family: Inter;
        }

        .van-cell {
            background: transparent;
            display: flex;
            align-items: center;

            .van-field__control {
                font-weight: 500;
                font-size: 16px;
            }
        }

        .label {
            font-size: 16px;
            font-weight: 500;
            display: flex;
            align-items: center;

            span {
                color: #fff;
            }

            img {
                width: 32px;
                height: 32px;
            }
        }
    }

    &-icon {
        margin: 12px 0;

        >img {
            width: 32px;
            height: 32px;
            margin: 0 auto;
        }
    }

    >.desc {
        margin-top: 24px;
        box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);
        background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
        border-radius: 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        >div {
            border-radius: 16px;
            padding: 16px;
            background: linear-gradient(241deg, #1E1D24 9%, #13121B 78%);
            backdrop-filter: blur(30px);
            border-radius: 16px;
            width: calc(100% - 2px);
            height: calc(100% - 2px);

            >div+div {
                margin-top: 16px;
            }

            >div {
                display: flex;
                justify-content: space-between;

                .label {
                    opacity: 0.6;
                    font-size: 14px;
                    letter-spacing: -0.25px;
                }

                .value {
                    letter-spacing: -0.25px;
                    font-size: 14px;
                }
            }
        }
    }

    >.btn {
        background: url('../../assets/img/exchange/btn2.png') no-repeat;
        background-size: 100% 100%;
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        height: 48px;
        color: #000000;
        margin-top: 40px;
    }
}

.exchange-loading {
    padding: 32px 20px 80px;

    >.title {
        display: flex;
        justify-content: space-between;
        line-height: 16px;
        font-size: 16px;

        >img {
            width: 20px;
            height: 20px;
        }
    }

    >.loading {
        padding-top: 64px;
        display: flex;
        height: 100px;
        justify-content: center;

        @keyframes ball-spin-fade-loader {
            50% {
                opacity: 0.3;
                -webkit-transform: scale(0.4);
                transform: scale(0.4);
            }

            100% {
                opacity: 1;
                -webkit-transform: scale(1);
                transform: scale(1);
            }
        }

        .ball-spin-fade-loader {
            position: relative;
            margin-left: -15px;
        }

        .ball-spin-fade-loader>div:nth-child(1) {
            top: 25px;
            left: 0;
            -webkit-animation: ball-spin-fade-loader 1s 0s infinite linear;
            animation: ball-spin-fade-loader 1s 0s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(2) {
            top: 17.04545px;
            left: 17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.12s infinite linear;
            animation: ball-spin-fade-loader 1s 0.12s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(3) {
            top: 0;
            left: 25px;
            -webkit-animation: ball-spin-fade-loader 1s 0.24s infinite linear;
            animation: ball-spin-fade-loader 1s 0.24s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(4) {
            top: -17.04545px;
            left: 17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.36s infinite linear;
            animation: ball-spin-fade-loader 1s 0.36s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(5) {
            top: -25px;
            left: 0;
            -webkit-animation: ball-spin-fade-loader 1s 0.48s infinite linear;
            animation: ball-spin-fade-loader 1s 0.48s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(6) {
            top: -17.04545px;
            left: -17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.6s infinite linear;
            animation: ball-spin-fade-loader 1s 0.6s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(7) {
            top: 0;
            left: -25px;
            -webkit-animation: ball-spin-fade-loader 1s 0.72s infinite linear;
            animation: ball-spin-fade-loader 1s 0.72s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(8) {
            top: 17.04545px;
            left: -17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.84s infinite linear;
            animation: ball-spin-fade-loader 1s 0.84s infinite linear;
        }

        .ball-spin-fade-loader>div {
            background: linear-gradient(133deg, #0DF1D5 2%, #0190D1 98%);
            width: 15px;
            height: 15px;
            border-radius: 100%;
            margin: 2px;
            -webkit-animation-fill-mode: both;
            animation-fill-mode: both;
            position: absolute;
        }
    }

    >.desc {
        margin-top: 16px;
        text-align: center;
        letter-spacing: -0.25px;
        font-size: 14px;
        opacity: 0.6;
    }
}

.exchange-claim {
    padding: 32px 20px 80px;

    >.title {
        display: flex;
        justify-content: space-between;
        line-height: 16px;
        font-size: 16px;

        >img {
            width: 20px;
            height: 20px;
        }
    }

    .claim-ok {
        padding-top: 68px;

        >img {
            width: 120px;
            height: 120px;
            margin: 0 auto;
        }

        >.title {
            font-size: 18px;
            margin-top: 16px;
            text-align: center;
            letter-spacing: -0.25px;
        }

        >.desc {
            font-size: 14px;
            margin-top: 8px;
            letter-spacing: -0.25px;
            display: flex;
            align-items: center;
            justify-content: center;

            span {
                opacity: 0.6;

            }

            img {
                width: 16px;
                height: 16px;
                margin-left: 7px;
            }
        }
    }

}

.node-popup {
    .desc {
        margin-top: 32px !important;
    }

    .node-popup-btn {
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        margin-top: 40px;

        .nook {
            width: 160px;
            display: flex;
            height: 48px;
            align-items: center;
            justify-content: center;

            background: url('../../assets/img/exchange/btn.png') no-repeat;
            background-size: 100% 100%;

            div {
                font-size: 16px;
              background: linear-gradient(104deg, #0DF1D5 0%, #0190D1 97%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                text-fill-color: transparent;
            }
        }

        .ok {
            display: flex;
            align-items: center;
            justify-content: center;
            background: url('../../assets/img/exchange/btn3.png') no-repeat;
            background-size: 100% 100%;
            width: 160px;
            height: 48px;
            font-size: 16px;
            border-radius: 16px;
          color: #000000;
        }
    }
}
.market-c-r {
    flex: 1;

    .ipt {
        flex: 1;

        .van-cell {
            background: transparent;
            padding-right: 0;
            input {
                color: #fff;
                text-align: right;

            }
        }
    }
}
</style>